import { createUseStyles } from "react-jss";
import * as Mixins from "../../../theme/Mixins";

export default createUseStyles({
    selectedWord: {
        composes: "selected-word",
        "background-color": "#2366DB",
        color: "#FFFFFF",
    },
    selectedCategory0: ({ category0Color }) => ({
        composes: "selected-category-0",
        "background-color": category0Color,
        color: "white",
        marginRight: "2px", // Add spacing between highlighted words
    }),
    selectedCategory1: ({ category1Color }) => ({
        composes: "selected-category-1",
        "background-color": category1Color,
        color: "white",
        marginRight: "2px", // Add spacing between highlighted words
    }),
    selectedCategory2: ({ category2Color }) => ({
        composes: "selected-category-2",
        "background-color": category2Color,
        color: "white",
        marginRight: "2px", // Add spacing between highlighted words
    }),
    selectedCategory3: ({ category3Color }) => ({
        composes: "selected-category-3",
        "background-color": category3Color,
        color: "white",
        marginRight: "2px", // Add spacing between highlighted words
    }),
    selectedCategory4: ({ category4Color }) => ({
        composes: "selected-category-4",
        "background-color": category4Color,
        color: "white",
        marginRight: "2px", // Add spacing between highlighted words
    }),
    selectedCategory5: ({ category5Color }) => ({
        composes: "selected-category-5",
        "background-color": category5Color,
        color: "white",
        marginRight: "2px", // Add spacing between highlighted words
    }),
    saveButton: {
        composes: "save__button",
        "background-color": "#3AAAEA",
        color: "white",
        "font-family": "Open Sans",
        "font-size": "14px",
        "font-weight": "600",
        "line-height": "19px",
        "letter-spacing": "0em",
        "text-align": "center",
        width: "104.61px",
        height: "33px",
        "border-radius": "8px",
    },
    saveButtonDisabled: {
        composes: "save__button__disabled",
        "background-color": "#F3F3F3",
        color: "#000000",
        "font-family": "Open Sans",
        "font-size": "14px",
        "font-weight": "600",
        "line-height": "19px",
        "letter-spacing": "0em",
        "text-align": "center",
        width: "104.61px",
        height: "33px",
        "border-radius": "8px",
    },
    cancelButton: {
        composes: "cancel__button",
        width: "104.82px",
        height: "33px",
        background: "#F3F3F3",
        "border-radius": "8px",
        color: "#000000",
        "font-weight": "600",
        "font-family": "Open Sans",
    },
    cancelButtonHover: {
        composes: "cancel__button buttonActive",
        color: "black",
    },
    deleteButton: {
        composes: "delete__button",
        width: "104.82px",
        height: "33px",
        background: "#FF006F",
        color: "#FFFFFF",
        "border-radius": "8px",
        "font-weight": "600",
        "font-family": "Open Sans",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
    },
    withFormatDisableUserSelection: {
        display: "flex",
        flexFlow: "wrap",
        // Enable text selection for highlighting functionality
        WebkitTouchCallout: "default",
        WebkitUserSelect: "text",
        KhtmlUserSelect: "text",
        MozUserSelect: "text",
        msUserSelect: "text",
        userSelect: "text",
        touchAction: "manipulation",
    },
    withoutFormatDisableUserSelection: (theme) => ({
        // Enable text selection for highlighting functionality
        WebkitTouchCallout: "default",
        WebkitUserSelect: "text",
        KhtmlUserSelect: "text",
        MozUserSelect: "text",
        msUserSelect: "text",
        userSelect: "text",
        touchAction: "manipulation",
        border: "1px solid currentColor",
        padding: "8px",
        color: theme.NeutralDarkColor,
    }),
    withoutFormatButtonWrapper: {
        marginRight: "7px", // Increased by 2px for better spacing between words
    },
    NonhighlightableTextUnderlined: ({ theme }) => ({
        
    }),
    NonhighlightableText:({ theme }) => ({
        color: theme.NeutralDarkColor,
    }),
    underlinedHighlightable: ({ theme }) => ({
        position: "relative",
        display: "inline-block",
        marginRight: "2px", // Add spacing between underlined words
        color:  Mixins.darken(theme.NeutralDarkColor, 1),
        // Create custom underline 2px higher than normal, extended to connect with sidebars
        "&::after": {
            content: "''",
            position: "absolute",
            left: "-1px", // Extend 2px to the left to connect with left sidebar
            right: "0px", // Extend 2px to the right to connect with right sidebar
            bottom: "0px", // Position 2px higher than normal (-1px + 2px = 1px)
            height: "1px",
            background: "currentColor",
            display: "block",
            pointerEvents: "none",
            zIndex: 1,
        },

        // Create both sidebars using ::before, positioned 2px further outward
        "&::before": {
            content: "''",
            position: "absolute",
            left: "-1px",
            right: "0px",
            bottom: "0px",
            height: "6px",
            borderLeft: "1px solid currentColor",
            borderRight: "1px solid currentColor",
            display: "block",
            pointerEvents: "none",
            zIndex: 2,
        },

        // Print support - use normal text underline instead of custom styling
        "@media print": {
            textDecoration: "underline",
            borderBottom: "none",
            paddingLeft: "0",
            paddingRight: "0",
            marginBottom: "0",
            "&::before, &::after": {
                display: "none",
            },
        },
    }),
    highlightableHover: {
        // Create background that matches underline boundaries exactly using box-shadow
        // This approach doesn't affect layout or positioning
        backgroundColor: "lightgrey", // Base background for the text area
        marginRight: "2px", // Add spacing between highlighted words
    },
    textHighlighterActionsWrapper: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        marginBottom: "10px",
        gap: "10px",
    },
    actionButton: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "5px 10px",
        minWidth: "72px",
        borderRadius: ({ theme }) => theme.BorderRadius,
        border: ({ theme }) => `${theme.BorderWidth}px solid ${theme.ControlBorderColor}`,
        backgroundColor: ({ theme }) => Mixins.alpha(theme.ButtonBackground, theme.ControlAlpha),
        color: ({ theme }) => Mixins.foregroundColor(theme, Mixins.buttonBackgroundColor(theme)),
        fontSize: "14px",
        fontFamily: ({ theme }) => `"${theme.TextFont}", sans-serif`,
        fontWeight: "600",
        cursor: "pointer",
        transition: "background-color 0.2s ease, color 0.2s ease",
        "&:hover": {
            backgroundColor: ({ theme }) => Mixins.darken(theme.ButtonBackground, 0.1),
            color: ({ theme }) => Mixins.foregroundColor(theme, Mixins.buttonBackgroundColor(theme)),
        },
    },
    actionButtonHidden: {
        display: "none",
    },
    actionButtonDisabled: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "5px 10px",
        minWidth: "72px",
        borderRadius: ({ theme }) => theme.BorderRadius,
        border: ({ theme }) => `${theme.BorderWidth}px solid ${Mixins.alpha(theme.ControlBorderColor, 0.3)}`,
        backgroundColor: ({ theme }) => Mixins.alpha(theme.ControlBackground, 0.1),
        color: ({ theme }) => Mixins.alpha(Mixins.foregroundColor(theme, Mixins.controlBackgroundColor(theme)), 0.4),
        fontSize: "14px",
        fontFamily: ({ theme }) => `"${theme.TextFont}", sans-serif`,
        fontWeight: "600",
        cursor: "not-allowed",
        opacity: "0.6",
    },
    actionButtonIcon: {
        width: "16px",
        height: "16px",
        fill: ({ theme }) => Mixins.foregroundColor(theme, Mixins.buttonBackgroundColor(theme)),
    },
    // Dropdown and open end container styles
    openEndContainer: {
        marginTop: "8px",
    },
    openEndRowContainer: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        "& > div": {
            flex: 1,
            margin: 0
        },
    },
    buttonsContainer: {
        display: "flex",
        justifyContent: "flex-start",
        gap: "8px",
        marginTop: "12px",
    },
    cancelButtonInline: ({ theme }) => ({
        padding: "5px 10px",
        backgroundColor: "transparent",
        border: `1px solid ${theme.ControlBorderColor}`,
        borderRadius: `${theme.BorderRadius}px`,
        cursor: "pointer",
        fontSize: "14px",
        minWidth: "72px",
        fontWeight: "500",
    }),
    confirmButton: ({ theme }) => ({
        padding: "5px 10px",
        backgroundColor: theme.PrimaryColor,
        border: "none",
        borderRadius: `${theme.BorderRadius}px`,
        cursor: "pointer",
        fontSize: "14px",
        color: theme.WhiteColor,
        minWidth: "72px",
        fontWeight: "500",
    }),
    confirmIconButton: ({ theme }) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "28px",
        height: "28px",
        padding: "0",
        backgroundColor: theme.PrimaryColor,
        border: "none",
        borderRadius: "50%",
        cursor: "pointer",
        color: theme.WhiteColor,
    }),
    // Error state styles
    openEndContainerError: ({ theme }) => ({
        marginTop: "8px",
        "& textarea": {
            borderColor: `${theme.ErrorColor} !important`,
        },
    }),
    dropdownSelectError: ({ theme }) => ({
        borderColor: `${theme.ErrorColor} !important`,
    }),
    categoryQuestionText: ({ theme }) => ({
        marginBottom: "4px",
        fontSize: "14px",
        color: theme.NeutralDarkColor,
        fontWeight: "600",
    }),
    categoryQuestionTextError: ({ theme }) => ({
        color: theme.ErrorColor,
    }),
    // Text selection styles
    highlightableText: (theme) => ({
        color: theme.NeutralDarkColor,
        cursor: "pointer",
        transition: "background-color 0.1s ease-in-out",
        borderRadius: "2px",
        padding: "1px 2px",
        margin: "0 1px",
        willChange: "background-color", // Optimize for background color changes
    }),
    
    // Mobile modal styles
    mobileModalContent: ({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        height: "100%",
        backgroundColor: theme.WhiteColor,
        color: Mixins.foregroundColor(theme, Mixins.wrapperBackgroundColor(theme)),
        lineHeight: Mixins.getLineHeight(theme.TextFontSize, theme.LineHeight, theme.BaseFontSize),
    }),
    mobileModalHeader: ({ theme }) => ({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "23px 16px 0",
        borderBottom: `1px solid ${theme.ControlBorderColor}`,
        backgroundColor: theme.WhiteColor,
    }),
    mobileModalTitle: ({ theme }) => ({
        margin: "0",
        fontSize: "18px",
        fontWeight: "600",
        color: theme.NeutralDarkColor,
        fontFamily: `"${theme.TextFont}", sans-serif`,
    }),
    mobileModalCloseButton: ({ theme }) => ({
        background: "none",
        border: "none",
        fontSize: "24px",
        color: theme.ForegroundColorDark,
        cursor: "pointer",
        padding: "4px",
        lineHeight: "1",
        minWidth: "32px",
        minHeight: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            color: theme.NeutralDarkColor,
        },
    }),
    mobileModalBody: ({ theme }) => ({
        flex: "1",
        padding: "20px",
        overflowY: "auto",
        backgroundColor: theme.WhiteColor,
    }),
    mobileModalSection: ({ theme }) => ({
        fontFamily: `"${theme.TextFont}", sans-serif`,
        marginBottom: "8px",
        "&:last-child": {
            marginBottom: "0",
        },
    }),
    mobileModalLabel: ({ theme }) => ({
        display: "block",
        marginBottom: "8px",
        fontSize: "16px",
        fontWeight: "500",
        color: theme.NeutralDarkColor,
        fontFamily: `"${theme.TextFont}", sans-serif`,
    }),
    mobileModalError: ({ theme }) => ({
        marginTop: "8px",
        fontSize: "14px",
        color: theme.ErrorColor,
        fontFamily: `"${theme.TextFont}", sans-serif`,
    }),
    mobileModalSelectionInfo: ({ theme }) => ({
        padding: "12px 16px",
        backgroundColor: theme.ControlBackground,
        borderRadius: "8px",
        fontSize: "14px",
        color: theme.ForegroundColorDark,
        fontFamily: `"${theme.TextFont}", sans-serif`,
    }),
    mobileModalFooter: ({ theme }) => ({
        padding: "16px 20px",
        borderTop: `1px solid ${theme.ControlBorderColor}`,
        backgroundColor: theme.WhiteColor,
        display: "flex",
        flexDirection: "column",
        gap: "12px",
    }),
    mobileModalDeleteButton: ({ theme }) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        padding: "12px 16px",
        backgroundColor: theme.ErrorColor,
        color: theme.WhiteColor,
        border: "none",
        borderRadius: "8px",
        fontSize: "16px",
        fontWeight: "600",
        fontFamily: `"${theme.TextFont}", sans-serif`,
        cursor: "pointer",
        minHeight: "48px",
        "&:hover": {
            backgroundColor: Mixins.darken(theme.ErrorColor, 0.1),
        },
    }),
    mobileModalActionButtons: {
        display: "flex",
        gap: "12px",
    },
    mobileModalCancelButton: ({ theme }) => ({
        flex: "1",
        padding: "12px 16px",
        backgroundColor: "transparent",
        color: theme.ForegroundColorDark,
        border: `1px solid ${theme.ControlBorderColor}`,
        borderRadius: "8px",
        fontSize: "16px",
        fontWeight: "500",
        fontFamily: `"${theme.TextFont}", sans-serif`,
        cursor: "pointer",
        minHeight: "48px",
        "&:hover": {
            backgroundColor: theme.ControlBackground,
        },
    }),
    mobileModalConfirmButton: ({ theme }) => ({
        flex: "1",
        padding: "12px 16px",
        backgroundColor: theme.PrimaryColor,
        color: theme.WhiteColor,
        border: "none",
        borderRadius: "8px",
        fontSize: "16px",
        fontWeight: "600",
        fontFamily: `"${theme.TextFont}", sans-serif`,
        cursor: "pointer",
        minHeight: "48px",
        "&:hover": {
            backgroundColor: Mixins.darken(theme.PrimaryColor, 0.1),
        },
    }),
    mobileHighlightableTextContainer: ({ theme }) => ({
        padding: "16px",
        borderRadius: "8px",
        border: `1px solid ${theme.ControlBorderColor}`,
        fontFamily: `"${theme.TextFont}", sans-serif`,
        color: theme.NeutralDarkColor,
        fontSize: "14px",
        // Enable text selection and touch events for mobile highlighting
        WebkitTouchCallout: "default",
        WebkitUserSelect: "text",
        KhtmlUserSelect: "text",
        MozUserSelect: "text",
        msUserSelect: "text",
        userSelect: "text",
        // Ensure touch events work properly
        touchAction: "manipulation",
    }),
    mobileOpenEndRowContainer: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        "& > div": {
            flex: 1,
            margin: 0
        },
    },
    mobileConfirmIconButton: ({ theme }) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "40px",
        height: "40px",
        padding: "0",
        backgroundColor: theme.PrimaryColor,
        border: "none",
        borderRadius: "50%",
        cursor: "pointer",
        color: theme.WhiteColor,
        flexShrink: 0,
        "&:hover": {
            backgroundColor: Mixins.darken(theme.PrimaryColor, 0.1),
        },
    }),
    mobileModalInlineButtons: {
        display: "flex",
        gap: "12px",
        marginTop: "16px",
    },
    mobileSelectedTextDisplay: ({ theme }) => ({
        padding: "8px 12px",
        backgroundColor: theme.ControlBackground,
        borderRadius: "8px",
        border: `1px solid ${theme.ControlBorderColor}`,
        marginTop: "4px",
    }),
    mobileSelectedTextItem: ({ theme }) => ({
        fontWeight: "500",
        color: theme.NeutralDarkColor,
    }),
    
    // Text Highlighter Selection Styles
    highlightableTextSelectedNoIndicators: {
        backgroundColor: "var(--highlighter-selection-bg, rgba(49, 106, 238, 0.2)) !important",
        position: "relative !important",
        color: "inherit !important",
    },
    
    highlightableTextHovered: {
        backgroundColor: "var(--highlighter-selection-bg, rgba(49, 106, 238, 0.2)) !important",
        color: "inherit !important",
    },
    
    highlightableTextSelected: {
        backgroundColor: "var(--highlighter-selection-bg, rgba(49, 106, 238, 0.2)) !important",
        position: "relative !important",
        color: "inherit !important",
        
        // Mobile-specific styles
        "@media (max-width: 768px)": {
            "&::before": {
                border: "none !important",
                content: '""',
                position: "absolute !important",
                left: "-4px !important",
                top: "8px !important",
                transform: "translateY(-50%) !important",
                width: "8px !important",
                height: "30px !important",
                backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIzMSIgdmlld0JveD0iMCAwIDkgMzEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNSA4Ljk3MjU0QzcuMjQ5OTggOC43MjM4MSA5IDYuODE2MjggOSA0LjVDOSAyLjAxNDcyIDYuOTg1MjggMCA0LjUgMEMyLjAxNDcyIDAgMCAyLjAxNDcyIDAgNC41QzAgNi44MTYyOCAxLjc1MDAyIDguNzIzODEgNCA4Ljk3MjU0VjMwLjVDNCAzMC43NzYxIDQuMjIzODYgMzEgNC41IDMxQzQuNzc2MTQgMzEgNSAzMC43NzYxIDUgMzAuNVY4Ljk3MjU0WiIgZmlsbD0iIzMxNkFFRSIvPgo8L3N2Zz4K") !important',
                backgroundRepeat: "no-repeat !important",
                backgroundSize: "contain !important",
                zIndex: "0 !important",
            },
            "&::after": {
                border: "none !important",
                content: '""',
                position: "absolute !important",
                right: "-4px !important",
                top: "16px !important",
                transform: "translateY(-50%) !important",
                width: "8px !important",
                height: "30px !important",
                backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIzMSIgdmlld0JveD0iMCAwIDkgMzEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNC41IDBDNC4yMjM4NiAwIDQgMC4yMjM4NTcgNCAwLjVWMjIuMDI3NUMxLjc1MDAyIDIyLjI3NjIgMCAyNC4xODM3IDAgMjYuNUMwIDI4Ljk4NTMgMi4wMTQ3MiAzMSA0LjUgMzFDNi45ODUyOCAzMSA5IDI4Ljk4NTMgOSAyNi41QzkgMjQuMTgzNyA3LjI0OTk4IDIyLjI3NjIgNSAyMi4wMjc1VjAuNUM1IDAuMjIzODU4IDQuNzc2MTQgMCA0LjUgMFoiIGZpbGw9IiMzMTZBRUUiLz4KPC9zdmc+Cg==") !important',
                backgroundRepeat: "no-repeat !important",
                backgroundSize: "contain !important",
                zIndex: "0 !important",
            },
        },
    },
});
